export const POSTS_PER_PAGE = 5;

export const topicTypeLabel: Record<string, { label: string; color: string }> = {
  STANDARD: { label: "Actualité", color: "bg-blue-50 text-blue-700 border-blue-100" },
  EVENT: { label: "Événement", color: "bg-purple-50 text-purple-700 border-purple-100" },
  OFFER: { label: "Offre", color: "bg-green-50 text-green-700 border-green-100" },
  ALERT: { label: "Alerte", color: "bg-red-50 text-red-700 border-red-100" },
};